export default {"src":"/_next/static/media/cape-verde.e20fcfaf.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};